<template>
  <tbody v-if="Object.keys(nearMatch).length !== 0">
    <tr>
      <td class="table-header-normal nm-table-header">
        <div class="">
          {{ nearMatch.pidSubmission.firstName}} {{ nearMatch.pidSubmission.lastName }}
        </div>
        <div class="text-gray-light">
            Local ID: {{ nearMatch.pidSubmission.localStudentId}}
        </div>
      </td>
      <td>
        <div>
            <router-link
              :to="{
                name: 'PIDistrictInfoDetails',
                params: { code: nearMatch.pidSubmission.districtCode  },
              }"
              class="has-text-weight-bold has-text-primary" style="font-size:14px"
            >
              {{ nearMatch.pidSubmissionDistrictName }}
            </router-link>
          <span class="padding-left--small has-text-grey is-italic">
            ({{ nearMatch.pidSubmission.districtCode }})</span>
        </div>
        <div class="font-italic text-gray-light is-italic">
          <router-link :to="{
                name: 'PISchoolInfoDetails',
                params: { districtCode: nearMatch.pidSubmission.districtCode,
                  schoolCode: nearMatch.pidSubmission.schoolCode },
              }">
            {{ nearMatch.pidSubmissionSchoolName }}
          </router-link>
          <span class="padding-left--small has-text-grey is-italic">
            ({{ nearMatch.pidSubmission.schoolCode }})</span>
        </div>
      </td>
      <td>
        <div>
            Transaction ID:
            <router-link
            :to="{ path:`/personId/individualMatch/${nearMatch.pidSubmissionId}/details`}"
            class="has-text-weight-bold has-text-primary"
            >
              {{ nearMatch.pidSubmissionId }}
            </router-link>
        </div>
        <div>
            Batch ID:
            <router-link v-if="nearMatch.pidBatchId"
              :to="{ path: `/personid/batch/${nearMatch.pidBatchId}/details` }"
              class="has-text-weight-bold has-text-primary">
                {{ nearMatch.pidBatchId }}
            </router-link>
            <div v-else>
              --
            </div>
        </div>
      </td>
      <td class="list-content">
        <router-link
          :to="{
            path: `/personid/compare/${nearMatch.pidSubmissionId}`,
          }"
          title="View Details"
         >
          <font-awesome-icon :icon="['far', 'angle-double-right']" size="2x"/>
        </router-link>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faAngleDoubleRight,
);

export default {
  props: {
    nearMatch: {
      type: Object,
      required: true,
    },
  },

};
</script>

<style lang="sass" scoped>
  .near-match--row
    padding: 0.5rem 1rem
    border-bottom: 1px solid #eee

  .nm-table-header
    font-weight: 400
    color: black
    vertical-align: middle
    padding-left: 1rem
    padding-right: 1rem
</style>
